var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage, defineMessages } from 'react-intl';
import * as stakeStates from '../../constants/StakeStatus';
import React, { PureComponent } from 'react';
import { KK, RU, UZ } from '../../constants/Language';
import * as BetType from '../../constants/BetType';
import InnerItem from './ComplexInnerItem';
import PropTypes from 'prop-types';
import moment from 'moment';
var messages = defineMessages({
    stake_amount: {
        id: 'briefcase_stake_amount',
        defaultMessage: 'Сумма',
    },
    Combo: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс из',
    },
    loseToWinAccumulator: {
        id: 'bet_type.loseToWinAccumulator',
        defaultMessage: 'Антиэкспресс',
    },
    system2: {
        id: 'bet_type.system',
        defaultMessage: 'Система {rank} из {count}',
    },
    system: {
        id: 'bet_type.system_2',
        defaultMessage: 'Система',
    },
    stake_state_1: {
        id: 'stake_state_1',
        defaultMessage: 'Активна',
    },
    stake_state_2: {
        id: 'stake_state_2',
        defaultMessage: 'Выигрыш',
    },
    stake_state_3: {
        id: 'stake_state_3',
        defaultMessage: 'Проигрыш',
    },
    stake_state_4: {
        id: 'stake_state_4',
        defaultMessage: 'Возврат',
    },
    stake_state_5: {
        id: 'stake_state_5',
        defaultMessage: 'Продана',
    },
    stake_state_10: {
        id: 'stake_state_10',
        defaultMessage: 'Возврат',
    },
    stake_state_0: {
        id: 'stake_state_0',
        defaultMessage: 'Неизвестна',
    },
    freebet_simple_hint: {
        id: 'member-area.freebet_simple_hint',
        defaultMessage: 'Freebet',
    },
});
function getMessage(betType) {
    var message = null;
    switch (betType) {
        case BetType.EXPRESS:
            message = messages.Combo;
            break;
        case BetType.SYSTEM:
            message = messages.system;
            break;
        case BetType.ANTIEXPRESS:
            message = messages.loseToWinAccumulator;
            break;
    }
    return message;
}
function fetchGeneralStateMsg(stake) {
    var complexStatus = '';
    var complexCls = 'refund';
    if (stake.StakeState == stakeStates.WON ||
        stake.StakeState == stakeStates.SOLD) {
        complexStatus = messages.stake_state_1;
        complexCls = 'active';
    }
    else if (stake.StakeState === stakeStates.LOST) {
        if (stake.StakePaymentAmount == 0) {
            complexStatus = messages.stake_state_3;
            complexCls = 'lost';
        }
        else if (stake.StakePaymentAmount == stake.StakeAmount) {
            complexStatus = messages.stake_state_4;
            complexCls = 'refund';
        }
        else {
            complexStatus = messages.stake_state_2;
            complexCls = 'win';
        }
    }
    else if (stake.StakeState === stakeStates.REFUND) {
        complexStatus = messages.stake_state_10;
        complexCls = 'refund';
    }
    else {
        complexStatus = messages.stake_state_0;
        complexCls = 'refund';
    }
    return {
        complexStatus: complexStatus,
        complexCls: complexCls,
    };
}
function getSuffix(length) {
    switch (length) {
        case 1:
            return '-го';
        case 2:
        case 3:
        case 4:
            return '-х';
        case 8:
            return '-ми';
        case 21:
        case 31:
        case 41:
        case 51:
        case 61:
        case 71:
        case 81:
        case 91:
            return '-го';
        default:
            return '-и';
    }
}
var Complex = /** @class */ (function (_super) {
    __extends(Complex, _super);
    function Complex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showInner: false,
        };
        _this.toggleInner = function () {
            var showInner = _this.state.showInner;
            _this.setState({
                showInner: !showInner,
            });
        };
        return _this;
    }
    Complex.prototype.render = function () {
        var _a = this.props, betsDataItem = _a.betsDataItem, languageId = _a.languageId;
        var showInner = this.state.showInner;
        var itemCls = showInner ? 'items-inner' : 'hidden';
        var factors = betsDataItem.Factors;
        var InnerItems = [];
        var betTypeMsg = getMessage(betsDataItem.StakeType);
        var isFreebet = betsDataItem.IsFreebet;
        var complexStatus = fetchGeneralStateMsg(betsDataItem).complexStatus;
        factors.map(function (factor, i) {
            InnerItems.push(_jsx(InnerItem, { factor: factor }, i));
        });
        var outcomeNameCls = showInner
            ? ' history__bet__outcome__name--toggled'
            : '';
        var title = '';
        if (languageId === RU) {
            if (betsDataItem.StakeType === BetType.SYSTEM) {
                title = (_jsx("strong", { children: _jsx(FormattedMessage, __assign({}, messages.system2, { values: {
                            rank: betsDataItem.StakeRank,
                            count: betsDataItem.Factors.length,
                        } })) }));
            }
            else {
                var suffix = getSuffix(betsDataItem.Factors.length);
                title = (_jsxs("strong", { children: [_jsx(FormattedMessage, __assign({}, betTypeMsg, { values: {
                                rank: betsDataItem.StakeRank,
                                count: betsDataItem.Factors.length,
                            } })), ' ', "\u0438\u0437 ", _jsx("span", { children: betsDataItem.Factors.length }), suffix, " \u0441\u043E\u0431\u044B\u0442\u0438\u0439"] }));
            }
        }
        else if (languageId === UZ) {
            if (betsDataItem.StakeType === BetType.SYSTEM) {
                title = (_jsx("strong", { children: _jsx(FormattedMessage, __assign({}, messages.system2, { values: {
                            rank: betsDataItem.StakeRank,
                            count: betsDataItem.Factors.length,
                        } })) }));
            }
            else {
                title = (_jsxs("strong", { children: [_jsx(FormattedMessage, __assign({}, betTypeMsg, { values: {
                                rank: betsDataItem.StakeRank,
                                count: betsDataItem.Factors.length,
                            } })), ' ', _jsx("span", { children: betsDataItem.Factors.length }), "ta voqeadan"] }));
            }
        }
        else if (languageId === KK) {
            if (betsDataItem.StakeType === BetType.SYSTEM) {
                title = (_jsx("strong", { children: _jsx(FormattedMessage, __assign({}, messages.system2, { values: {
                            rank: betsDataItem.StakeRank,
                            count: betsDataItem.Factors.length,
                        } })) }));
            }
            else {
                title = (_jsxs("strong", { children: [_jsx(FormattedMessage, __assign({}, betTypeMsg, { values: {
                                rank: betsDataItem.StakeRank,
                                count: betsDataItem.Factors.length,
                            } })), ' ', "- ", _jsx("span", { children: betsDataItem.Factors.length }), " \u043E\u049B\u0438\u0493\u0430\u0434\u0430\u043D"] }));
            }
        }
        else {
            if (betsDataItem.StakeType === BetType.SYSTEM) {
                title = (_jsxs("strong", { children: [_jsx(FormattedMessage, __assign({}, messages.system2, { values: {
                                rank: betsDataItem.StakeRank,
                                count: betsDataItem.Factors.length,
                            } })), ' ', "events"] }));
            }
            else {
                title = (_jsxs("strong", { children: [_jsx(FormattedMessage, __assign({}, betTypeMsg, { values: {
                                rank: betsDataItem.StakeRank,
                                count: betsDataItem.Factors.length,
                            } })), ' ', "- ", _jsx("span", { children: betsDataItem.Factors.length }), " events"] }));
            }
        }
        return (_jsxs("div", __assign({ className: "history__bet" }, { children: [_jsxs("div", __assign({ className: "history__bet__head" }, { children: [_jsxs("div", __assign({ className: "history__bet__head__left" }, { children: [_jsx(FormattedMessage, __assign({}, betTypeMsg, { values: {
                                        rank: betsDataItem.StakeRank,
                                        count: betsDataItem.Factors.length,
                                    } })), "\u2116 ", betsDataItem.StakeId] })), _jsx("div", __assign({ className: "history__bet__head__right" }, { children: moment(betsDataItem.StakeReceptionDate).format('DD.MM.YYYY, HH:mm') }))] })), _jsxs("div", __assign({ className: "history__bet__body" }, { children: [_jsxs("div", __assign({ className: "history__bet__row history__bet__outcome", onClick: this.toggleInner }, { children: [_jsx("div", __assign({ className: "history__bet__body__left history__bet__outcome__name".concat(outcomeNameCls) }, { children: title })), _jsx("div", __assign({ className: "history__bet__body__right history__bet__outcome__rate" }, { children: betsDataItem.StakeFactorValue.toFixed(2) }))] })), _jsxs("div", __assign({ className: "history__bet__row history__bet__bet-amount" }, { children: [_jsxs("div", __assign({ className: "history__bet__body__left" }, { children: [_jsx(FormattedMessage, __assign({}, messages.stake_amount)), ":\u00A0", _jsxs("strong", { children: [betsDataItem.StakeAmount.toFixed(2), " "] }), isFreebet && (_jsx(FormattedMessage, __assign({}, messages.freebet_simple_hint, { children: function (m) { return _jsx("span", __assign({ className: "live" }, { children: m })); } })))] })), _jsx("div", __assign({ className: "history__bet__body__right" }, { children: _jsxs("div", __assign({ className: "history__bet__bet-amount__status history__bet__bet-amount__status--".concat(fetchGeneralStateMsg(betsDataItem).complexCls) }, { children: [_jsx(FormattedMessage, __assign({}, complexStatus)), betsDataItem.StakePaymentAmount > 0 && (_jsx("strong", { children: betsDataItem.StakePaymentAmount }))] })) }))] })), showInner && _jsx("div", __assign({ className: "".concat(itemCls) }, { children: InnerItems }))] }))] })));
    };
    Complex.propTypes = {
        betsDataItem: PropTypes.object.isRequired,
    };
    return Complex;
}(PureComponent));
export default Complex;



// WEBPACK FOOTER //
// ./src/components/betting-history/Complex.tsx